import DOMPurify from "dompurify";

// Renders blog/medication body content safely.
// If the body contains HTML tags (the external admin's rich-text editor saves
// HTML — e.g. <p>, <strong>, <ul>), sanitise it with DOMPurify then render.
// Otherwise fall back to plain-text paragraph splitting on double newlines.
const HTML_RE = /<\/?[a-z][\s\S]*?>/i;

// Small, deterministic hash so re-renders reuse the same key for identical
// paragraphs — avoids the "array index as key" React anti-pattern while
// staying dependency-free.
function keyFor(text, idx) {
  let h = 0;
  const s = text.slice(0, 80);
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) | 0;
  }
  return `p-${h}-${idx}`;
}

export default function BlogBody({ html, className = "" }) {
  const text = html || "";
  const isHtml = HTML_RE.test(text);

  if (isHtml) {
    const clean = DOMPurify.sanitize(text, {
      USE_PROFILES: { html: true },
      ADD_ATTR: ["target", "rel"],
    });
    return (
      <div
        className={`namya-prose ${className}`}
        dangerouslySetInnerHTML={{ __html: clean }}
      />
    );
  }

  const paras = text.split(/\n\n+/);
  return (
    <div className={className}>
      {paras.map((para, idx) => (
        <p
          key={keyFor(para, idx)}
          className="text-slate-700 text-lg leading-relaxed whitespace-pre-line mb-5"
        >
          {para}
        </p>
      ))}
    </div>
  );
}
